/* global Glide */
(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.featureSlider = {
    init: false,
    attach: function (context) {
      let options = {
        type: 'carousel',
        animationDuration: 300,
        perView: 1,
        animationTimingFunc: 'ease-in-out'
      };
      let carousels = context.querySelectorAll('.feature-slider__slide-container.glide');
      if (!Drupal.behaviors.featureSlider.init && typeof carousels != 'undefined' && carousels.length > 0) {
        Drupal.behaviors.featureSlider.init = true;
        Object.values(carousels).map(function (carousel) {
          let glide = new Glide(carousel, options);
          glide.mount();
          let rightArrow = carousel.querySelector('.glide__arrow--right');
          let leftArrow = carousel.querySelector('.glide__arrow--left');

          function goRight(e) {
            e.preventDefault();
            glide.go('>');
          }

          function goLeft(e) {
            e.preventDefault();
            glide.go('<');
          }

          rightArrow.addEventListener('click', goRight);
          leftArrow.addEventListener('click', goLeft);
        });
      }
    }
  };

  var sliders = document.getElementsByClassName('paragraph--type--feature-slider');
  if (window.innerWidth < 768) {
    for(let i = 0; i < sliders.length; i++) {
      var slider = sliders[i];

      if ($(slider).find('.feature-slider__slide-container--cta-content').length > 0) {
        var children = $(slider).find('.feature-slider__slide-container--cta-content');
        var overlayHeight = $(children[0]).height();
        var arrowPosition = overlayHeight / 2 + 50 + 'px';
        $(slider).find('.glide__arrows').css('bottom', arrowPosition);
      } else {
        $(slider).find('.glide__track').css('padding-bottom', '40px');
      }
    }
  }
}(jQuery, Drupal));
